import { useEffect, useRef, useState } from 'react';
import EditComponent from './GiftCardPlansEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { Button, Popover, Select, Space, Switch, Tooltip } from 'antd';
import dayjs from 'dayjs';
import GiftCardPlansApplicablesShops from './GiftCardPlansApplicablesShops';
import GiftCardPlansApplicablesMerchants from './GiftCardPlansApplicablesMerchants';
import GiftCardPlansApplicablesMembershipType from './GiftCardPlansApplicablesMembershipType';
import { columnsheadId } from '../../../utilsTsx/components/system/columnshead';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import antdMessage from '../../../utilsTsx/components/system/antdMessage';
import getList from '../../../utilsTsx/universal/getList';

const WebComponent = (props: any) => {
    const { defaultService } = props;
    const apiId = 'giftCardPlans';
    const ref = useRef<any>(undefined);
    const [giftCardPlansId, setGiftCardPlansId] = useState<any>();
    const [modalVisibleGiftCardPlansApplicablesShops, setModalVisibleGiftCardPlansApplicablesShops] = useState<any>();
    const [modalVisibleGiftCardPlansApplicablesMerchants, setModalVisibleGiftCardPlansApplicablesMerchants] = useState<any>();
    const [modalVisibleGiftCardPlansApplicablesMembershipType, setModalVisibleGiftCardPlansApplicablesMembershipType] = useState<any>();
    const [giftCardTypeData, setGiftCardTypeData] = useState<any>();
    const [fethcData, setFethcData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>({
        showPageData: {
            giftCardTypeId: 'allGiftCardType'
        }
    });
    /** 当前打开的 Popover ID */
    const [activePopoverId, setActivePopoverId] = useState<string | null>(null);

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setFethcData(() => ref.current.fetchData);
        }
        fetchApi.GET(urlService,
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'giftCardType',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { giftCardType } = res.data;
                    setGiftCardTypeData([{ id: 'allGiftCardType', name: '所有' }, ...giftCardType]);
                }
            })
    }, []);

    //表头
    const columnsHead = [
        {
            title: '方案',
            dataIndex: 'planName',
            render: (text: any) =>
                <Tooltip placement="topLeft" title={text}>{
                    text?.length >= 8 ? text?.substring(0, 8) + '......' : text
                }</Tooltip>
        },
        {
            title: '类型',
            dataIndex: 'giftCardType',
            render: (text: any) => text?.name
        },
        {
            title: '面值',
            dataIndex: 'faceValue'
        },
        {
            title: '使用规则',
            dataIndex: 'isPermanentUse',
            render: (val: boolean, record: any) => {
                return (
                    val === true ?
                        '永久使用' :
                        `${dayjs(record?.startDate).format('YYYY-MM-DD')} 至 ` +
                        `${dayjs(record?.endDate).format('YYYY-MM-DD')}；` +
                        `${record?.totalCopies - record?.usedCopies}/${record?.totalCopies}`
                )
            }
        },
        {
            title: '排序',
            dataIndex: 'sorting',
            sorter: true
        },
        {
            title: '适合商户',
            dataIndex: 'id',
            render: (val: any) => (
                <>
                    <Space>
                        <Button type='primary' onClick={() => {
                            setGiftCardPlansId({
                                giftCardPlansId: val
                            })
                            setModalVisibleGiftCardPlansApplicablesMerchants(true);
                        }}>{'适合商户'}</Button>
                    </Space>
                </>
            )
        },
        {
            title: '适合店铺',
            dataIndex: 'id',
            render: (val: any) => (
                <>
                    <Space>
                        <Button type='primary' onClick={() => {
                            setGiftCardPlansId({
                                giftCardPlansId: val
                            })
                            setModalVisibleGiftCardPlansApplicablesShops(true);
                        }}>{'适合店铺'}</Button>
                    </Space>
                </>
            )
        },
        {
            title: '会员类型',
            dataIndex: 'id',
            render: (val: any) => (
                <>
                    <Space>
                        <Button type='primary' onClick={() => {
                            setGiftCardPlansId({
                                giftCardPlansId: val
                            })
                            setModalVisibleGiftCardPlansApplicablesMembershipType(true);
                        }}>{'会员类型'}</Button>
                    </Space>
                </>
            )
        },
        {
            title: '复制',
            dataIndex: 'id',
            key: 'id',
            render: (val: any, record: any) => {
                return (
                    <Popover
                        title="是否复制？"
                        trigger="click"
                        content={(<Space>
                            <Button type='dashed' onClick={() => setActivePopoverId(null)}>否</Button>
                            <Button type='primary' onClick={() => {
                                fetchApi.PUT(defaultService,
                                    {
                                        body: {
                                            apiId: 'giftCardPlans',
                                            apiExtend: 'copy',
                                            apiVariable: val
                                        }
                                    }).then(res => {
                                        if (res?.success === true) {
                                            antdMessage('success', '复制成功');
                                            ref?.current?.fetchData?.();
                                        } else {
                                            antdMessage('error', res?.message);
                                        }
                                    });
                                setActivePopoverId(null);
                            }}>是</Button>
                        </Space>)}
                        open={activePopoverId === val}
                        onOpenChange={(visible) => {
                            setActivePopoverId(visible ? val : null);
                        }}
                    >
                        <Button type="dashed">复制</Button>
                    </Popover>
                )
            }
        },
        {
            title: '默认',
            dataIndex: 'isDefault',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                />
            )
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    const extendProps: WebUniversalProps = {
        ...props,
        titleName: '礼品卡方案',
        apiId,
        columns,
        editOptions: {
            Editor: EditComponent
        },
        serviceId: 'business'
    };

    return (
        <><Space>
            <Select
                showSearch
                placeholder="礼品卡状态"
                optionFilterProp="children"
                defaultValue={'allGiftCardType'}
                onChange={(e) => {
                    const cs = {
                        showPageData: {
                            ...sendPageData.showPageData,
                            giftCardTypeId: e
                        }
                    }
                    setSendPageData(cs);
                    fethcData({
                        apiId,
                        sendPageData: cs
                    });
                }}
                style={{ width: 130 }}
                filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(giftCardTypeData)}
            </Select>
        </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
            {modalVisibleGiftCardPlansApplicablesMerchants ?
                (<GiftCardPlansApplicablesMerchants
                    closeModal={() => setModalVisibleGiftCardPlansApplicablesMerchants(false)}
                    data={giftCardPlansId} />)
                : null}
            {modalVisibleGiftCardPlansApplicablesShops ?
                (<GiftCardPlansApplicablesShops
                    closeModal={() => setModalVisibleGiftCardPlansApplicablesShops(false)}
                    data={giftCardPlansId} />)
                : null}
            {modalVisibleGiftCardPlansApplicablesMembershipType ?
                (<GiftCardPlansApplicablesMembershipType
                    closeModal={() => setModalVisibleGiftCardPlansApplicablesMembershipType(false)}
                    data={giftCardPlansId} />)
                : null}
        </>
    )
}

export default WebComponent;
